import { ADMIN_NAV } from '../navConfig';

// Extra titles for routes reachable from within a screen (not top-level nav
// items) — so the Topbar always shows a real page name, never "מנהל מוקד".
const EXTRA_TITLES: Record<string, string> = {
  // נתיבים ישנים שמפנים ללשוניות (07/09/2026) — נשארים עם שם לרגע ההפניה.
  '/admin/agents': 'נציגים',
  '/admin/teams': 'צוותים',
  '/admin/roles': 'תפקידים והרשאות',
  '/admin/queues': 'תורים',
  '/admin/ivr': 'תפריט קולי (IVR)',
  '/admin/extensions': 'שלוחות',
  '/admin/blocked-numbers': 'מספרים חסומים',
  '/admin/voice-agents': 'טלפוניה',
  '/admin/dispositions': 'תיוג וסיום שיחה',
  '/admin/call-tags': 'תגיות שיחה',
  '/admin/voicemail': 'תא קולי',
  '/admin/crm': 'אנשי קשר',
  '/admin/api': 'API',
  '/admin/onboarding': 'הקמה ראשונית',
};

/** שם הדף הנוכחי לפי ההתאמה הארוכה ביותר מ-NAV (או מהמפה המשלימה). */
export function titleForPath(pathname: string): string {
  // Drop any query string / hash so '/admin/live?listen_agent=5' still matches.
  const path = pathname.replace(/[?#].*$/, '');
  const candidates: { to: string; he: string }[] = [
    ...ADMIN_NAV.flatMap((s) => s.items.map((it) => ({ to: it.to, he: it.he }))),
    ...Object.entries(EXTRA_TITLES).map(([to, he]) => ({ to, he })),
  ];
  let best: { to: string; he: string } | null = null;
  for (const c of candidates) {
    const exact = path === c.to;
    const nested = path.startsWith(c.to + '/');
    // '/admin' matches every path — accept it only as an exact match.
    if (exact || (nested && c.to !== '/admin')) {
      if (!best || c.to.length > best.to.length) best = c;
    }
  }
  return best?.he ?? 'מנהל מוקד';
}
